'use client';
import { useEffect } from 'react';
import i18nConfig from '@i18nConfig';

export default function NotFound() {
  // Get the user's preferred language or default to English
  const getPreferredLanguage = () => {
    if (typeof navigator === 'undefined') return i18nConfig.defaultLocale;

    // Check if the browser language matches any of our supported locales
    const browserLang = navigator.language.split('-')[0];
    const matchedLocale = i18nConfig.locales.find((locale) => locale.startsWith(browserLang));

    return matchedLocale || i18nConfig.defaultLocale;
  };

  useEffect(() => {
    // Redirect to the localized not-found page
    const locale = getPreferredLanguage();
    window.location.href = `/${locale}/not-found`;
  }, []);

  // This is just a fallback while the redirect happens
  return (
    <div
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
    >
      <p>Redirecting to not found page...</p>
    </div>
  );
}
